<template>
  <div>
    <div class="swiper-father-pc">
      <div class="swiper-container" id="wrap-pc">
        <div class="swiper-wrapper">
          <div class="swiper-slide" style="background: #F9F9F9;">
            <a href="javascript:;">
              <div class="hy">
                <img src="../../public/img/hy.png" style="width: 50px;height: 50px;margin-top: 30%;"/>
                <p>非标自动化</p>
              </div>
            </a>
          </div>
          <div class="swiper-slide">
            <a href="javascript:;">
              <img src="../../public/img/fb.jpg" />
            </a>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper';
  export default{
    data(){
      return {

      }
    },
    mounted(){
      new Swiper('#wrap-pc', {
        loop:true,
        autoplay:{
          stopOnLastSlide:true,
        },
        navigation: {
          nextEl: '.swiper-father-pc .swiper-button-next',
          prevEl: '.swiper-father-pc .swiper-button-prev',
        },
        slidesPerView:2,
        spaceBetween:10
      });
    }
  }
</script>
